import _ from 'lodash'
import {
    SERVERS_UPDATE_SERVERLIST,
    SERVERS_UPDATE_ACTIVE,
    SERVERS_SET_SERVER_STATUS,
    SERVERS_SET_ENABLED_LIST,
    SERVERS_SET_PROFILES,
} from '../constants'

const serversInitialState = {
    active: undefined,
    list: {},
}

// This is just to describe how a server in the list should look like
// const server = {
//     enabled: true,
//     name: 'Duality',
//     numPlayers: 0,
//     playButton: true,
//     shortName: 'duality',
//     showPlayers: false,
//     sso: {
//         slinger: 'slinger-duality.testeveonline.com',
//         url: 'dualitylogin.testeveonline.com',
//     },
//     status: 'offline',
//     statusLabel: 'Offline',
//     websiteUrl: 'https://launcher.testeveonline.com',
//     profiles: ['Duality'],
// }

function updateServer(state, payload) {
    let showPlayers = false
    let playButton = false
    let numPlayers = 0

    switch (payload.status) {
        case 'online':
            showPlayers = payload.count > 0
            playButton = true
            numPlayers = payload.count
            break
        case 'offline':
            break
        case 'vip':
            playButton = true
            numPlayers = payload.count
            break
        case 'unknown':
        default:
            playButton = true
    }

    return {
        ...state.list[payload.name],
        status: payload.status,
        showPlayers,
        playButton,
        numPlayers,
    }
}

export default function servers(state = serversInitialState, action) {
    // Deep clone the current state
    const clone = _.cloneDeep(state)

    switch (action.type) {
    // Update the list of EVE Online servers
        case SERVERS_UPDATE_SERVERLIST:
            return { ...clone, list: action.payload }

        // Update the name of the active server
        case SERVERS_UPDATE_ACTIVE: {
            return { ...clone, active: action.payload }
        }

        // Update a server status
        case SERVERS_SET_SERVER_STATUS: {
        // payload = { shortName, status, numPlayers }
            clone.list[action.payload.name] = updateServer(state, action.payload)
            return { ...clone }
        }

        // Update what servers are enabled based on the given list
        case SERVERS_SET_ENABLED_LIST: {
        // first disable all servers except for tq
            clone.list = _.mapValues(clone.list, (server) => {
                server.enabled = server.shortName === 'tq'
                return server
            })
            // Then enable all servers from the given list
            if (action.payload != null) {
                action.payload.map((server) => {
                    if (clone.list[server] != null) {
                        clone.list[server].enabled = true
                    }
                    return null
                })
            }

            return { ...clone }
        }

        // Update the list of profiles for the
        // active server
        case SERVERS_SET_PROFILES: {
            const { server, profiles } = action.payload
            const s = clone.list[server]
            if (s != null) {
                s.profiles = profiles
                if (s.profiles.length < 1) {
                    s.profiles.push('Default')
                }
            }
            return clone
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/servers.js